import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Paper from '../Paper';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 15,
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(3),
    width: 350,
    height: 200,
  },
  buttonContainer: {
    marginTop: theme.spacing(),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  addStamp: {
    width: 150,
  },
  title: {
    width: 150,
    fontWeight: theme.typography.fontWeightRegular,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: theme.palette.grey[500],
    textAlign: 'center',
  },
}));

type BlankStampCardProps = {
  handleAddStampCard: () => void;
  isAdminOnly: boolean;
};

export default function BlankStampCard({
  handleAddStampCard,
  isAdminOnly,
}: BlankStampCardProps) {
  const classes = useStyles();
  return (
    <Grid item xs={12} className={classes.root}>
      <Paper className={classes.cardContainer}>
        <div className={classes.buttonContainer}>
          {isAdminOnly ? (
            <Button
              color="primary"
              className={classes.addStamp}
              onClick={(e) => {
                handleAddStampCard();
              }}
            >
              Add Card
            </Button>
          ) : (
            <Typography variant="body2" className={classes.title}>
              <strong>Card may be added by Manager or Admin</strong>
            </Typography>
          )}
        </div>
      </Paper>
    </Grid>
  );
}
